module.exports = "<circle cx=\"10\" cy=\"2.5\" r=\"2.5\" />\n<circle cx=\"10\" cy=\"9.5\" r=\"2.5\" />\n<circle cx=\"10\" cy=\"16.5\" r=\"2.5\" />\n"